// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"686":"27d34243","824":"1cceba54"}[chunkId] + ".chunk.js";
};